// Dark-only categorical palette, adjacent-order CVD-validated against this app's
// card surface (#1d232a). Order is the safety mechanism -- do not reorder or cycle.
export const CATEGORICAL_COLORS = [
	"#3987e5", // 1 blue
	"#d95926", // 2 orange
	"#199e70", // 3 aqua
	"#c98500", // 4 yellow
	"#d55181", // 5 magenta
	"#008300", // 6 green
	"#9085e9", // 7 violet
	"#e66767", // 8 red
] as const;

// Fixed identity for the two-sided Yes/No markets this dashboard is built around.
export const SIDE_COLORS: Record<string, string> = {
	Yes: CATEGORICAL_COLORS[0],
	No: CATEGORICAL_COLORS[1],
	yes: CATEGORICAL_COLORS[0],
	no: CATEGORICAL_COLORS[1],
};

export function colorForSeries(name: string, index: number): string {
	return (
		SIDE_COLORS[name] ??
		CATEGORICAL_COLORS[index % CATEGORICAL_COLORS.length] ??
		CATEGORICAL_COLORS[0]
	);
}

export const CHART_INK = {
	primary: "#e1e1e6",
	secondary: "rgba(225,225,230,0.7)",
	muted: "rgba(225,225,230,0.5)",
	gridline: "rgba(225,225,230,0.1)",
	baseline: "rgba(225,225,230,0.2)",
	surfaceRing: "#1d232a",
};

export function formatCompactNumber(value: number): string {
	if (!Number.isFinite(value)) return "0";
	const abs = Math.abs(value);
	if (abs >= 1_000_000) return `${(value / 1_000_000).toFixed(2)}M`;
	if (abs >= 1_000) return `${(value / 1_000).toFixed(2)}K`;
	if (Number.isInteger(value)) return value.toLocaleString();
	return value.toLocaleString(undefined, { maximumFractionDigits: 2 });
}
